var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gender-icon",
    transform: "translate(-178)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    width: 16,
    height: 16,
    transform: "translate(178)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2181",
    "data-name": "Group 2181",
    transform: "translate(158.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2180",
    "data-name": "Group 2180",
    transform: "translate(20.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2179",
    "data-name": "Group 2179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4452",
    "data-name": "Path 4452",
    d: "M322.141,3.75a1.875,1.875,0,1,0-1.875-1.875A1.877,1.877,0,0,0,322.141,3.75Zm0-2.5a.625.625,0,1,1-.625.625A.626.626,0,0,1,322.141,1.25Z",
    transform: "translate(-310.891)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4453",
    "data-name": "Path 4453",
    d: "M24.641,139h-2.5a1.877,1.877,0,0,0-1.875,1.875v3.406a1.878,1.878,0,0,0,1.25,1.768v3.982a.625.625,0,0,0,1.25,0v-4.5a.625.625,0,0,0-.625-.625.626.626,0,0,1-.625-.625v-3.406a.626.626,0,0,1,.625-.625h2.5a.626.626,0,0,1,.625.625v3.406a.626.626,0,0,1-.625.625.625.625,0,0,0-.625.625v4.5a.625.625,0,0,0,1.25,0v-3.982a1.878,1.878,0,0,0,1.25-1.768v-3.406A1.877,1.877,0,0,0,24.641,139Z",
    transform: "translate(-20.266 -134.656)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4454",
    "data-name": "Path 4454",
    d: "M276.8,144.544a5.741,5.741,0,0,0-.96-1.938l.379-1.243a1.8,1.8,0,0,0-.257-1.579,1.76,1.76,0,0,0-1.371-.748h-1.756a1.76,1.76,0,0,0-1.371.748,1.8,1.8,0,0,0-.257,1.579l.379,1.243a8.061,8.061,0,0,0-1.333,4.566.625.625,0,0,0,.625.611h.938v2.281a.625.625,0,0,0,1.25,0v-2.906a.625.625,0,0,0-.625-.625h-.914a5.883,5.883,0,0,1,1.213-3.352.625.625,0,0,0,.143-.611L272.4,141a.561.561,0,0,1,.08-.492.515.515,0,0,1,.392-.222h1.674a.515.515,0,0,1,.392.222.561.561,0,0,1,.08.492l-.479,1.572a.625.625,0,0,0,.143.611,4.221,4.221,0,0,1,.914,1.718,8.2,8.2,0,0,1,.3,1.635h-.911a.625.625,0,0,0-.625.625v2.906a.625.625,0,0,0,1.25,0v-2.281h.938a.625.625,0,0,0,.625-.611A9.524,9.524,0,0,0,276.8,144.544Z",
    transform: "translate(-262.44 -134.69)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4455",
    "data-name": "Path 4455",
    d: "M62.141,3.75a1.875,1.875,0,1,0-1.875-1.875A1.877,1.877,0,0,0,62.141,3.75Zm0-2.5a.625.625,0,1,1-.625.625A.626.626,0,0,1,62.141,1.25Z",
    transform: "translate(-59.016)",
    fill: "gray"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderIcon);
export default __webpack_public_path__ + "static/media/gender-icon.3724c770a69ce103fe770a2d65e00c12.svg";
export { ForwardRef as ReactComponent };